<template>
  <section class="page">
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-10 offset-sm-1">
          <h2 class="title page__h1">レースエントリー</h2>
          <div class="box box--center mb-24">
            <p v-html="message">
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="border p-2">
            <div class="container bg-light mb-1 py-3">
              <div class="row">
                <div class="col-sm-3">
                    開催日
                </div>
                <div class="col-sm-4">
                    <input type="date" v-model="sprm.fromDate" class="form-control">
                </div>
                <div class="col-sm-1">
                    <span class="d-inline-block px-3">〜</span>
                </div>
                <div class="col-sm-4">
                    <input type="date" v-model="sprm.toDate" class="form-control">
                </div>
              </div>
            </div>
            <div class="container bg-light mb-1 py-3">
              <div class="row">
                <div class="col-sm-3">
                    ライセンス
                </div>
                <div class="col-sm-9">
                  <div v-if="Array.isArray(member_license_list) && member_license_list.length > 0">
                    <template v-for="member_license in member_license_list" :key="member_license.id" class="me-2">
                    <button @click="toggleSelectedLicense(member_license.old_short_label)" :class="btnSelectedLicenseClass(member_license.old_short_label)">{{ member_license.short_label }}</button>
                    </template>
                  </div>
                  <div v-else></div>
                  <div class="mt-8">
                    検索するライセンスを選択してください。
                  </div>
                </div>
              </div>
            </div>
            <div class="container bg-light mb-1 py-3">
              <div class="row">
                <div class="col-sm-3">
                    開催エリア
                </div>
                <div class="col-sm-1">
                    地方
                </div>
                <div class="col-sm-3">
                  <bs-select
                    :nullOption="true"
                    :options="selectAreaCd"
                    v-model="sprm.areaCd"
                  ></bs-select>
                </div>
                <div class="col-sm-1" v-if="sprm?.areaCd">
                    都道府県
                </div>
                <div class="col-sm-4">
                  <bs-select
                    v-if="sprm?.areaCd"
                    :nullOption="true"
                    :options="selectPrefCd(sprm.areaCd)"
                    v-model="sprm.prefCd"
                  ></bs-select>
                </div>
              </div>
            </div>
            <div class="container mb-1 py-3">
                <div class="row">
                    <div class="col-sm-4 offset-sm-4 ">
                        <a href="#search_list" @click="searchAction" class="button04 select_bg text-center d-block py-3 mb-2">この条件で検索する</a>
                    </div>
                    <div class="col-sm-4 text-center">
                        <a href="#search_form" @click="clearSearchParam" class="button03 select_bg_clear text-center d-inline-block px-3 py-2 mb-2">検索条件をクリア</a>
                    </div>
                </div>
            </div>
          </div>
        </div>
        
      </div>
      <div class="row">
        <div class="col-12 col-sm-10 offset-sm-1">
          <div class="row border-bottom py-3" v-for="(data, index) in list" :key="index">
            <div class="row mb-3">
                <div class="col-md-12">
                    <h4 class="title03 page__h3 " v-html="data.mfj_event_sub_data_event_name"></h4>
                    <!-- {{ data?.mfj_event_main_data_cd }}: {{ data?.mfj_event_sub_data_cd_seq }} -->
                </div>
            </div>
            <div class="row mb-1">
                <div class="col-sm-2 bg_org_gray p-2 text-center">
                    <h5 class="title08 page__h4">開催場所</h5>
                </div>
                <div class="col-sm-4 p-2" v-html="data.hall_name">
                </div>
                <div class="col-sm-2 bg_org_gray p-2 text-center">
                    <h5 class="title08 page__h4">開催期間</h5>
                </div>
                <div class="col-sm-4 p-2">
                    {{data.event_start}}〜{{data.event_end}}
                </div>
            </div>
            <div class="row mb-1" >
                <div class="col-sm-3 bg_org_gray p-2 text-center" v-if="data.entry_start != '0000-00-00' && data.entry_end != '0000-00-00'">
                    <h5 class="title08 page__h4">エントリー期間</h5>
                </div>
                <div class="col-sm-6 p-2" v-if="data.entry_start != '0000-00-00' && data.entry_end != '0000-00-00'">
                    {{data.entry_start}} 〜 {{data.entry_end}}
                </div>
            </div>
            <div class="row mb-1" >
                <div class="col-sm-2 bg_org_gray p-2 text-center">
                    <h5 class="title08 page__h4">主催者</h5>
                </div>
                <div class="col-sm-4 mb-1 p-2" v-if="data.race_owner_name">
                    <p v-html="data.race_owner_name"></p>
                </div>
            </div>
            <div class="row mb-1" v-if="data.mfj_event_main_data_url">
                <div class="col-sm-2 bg_org_gray p-2 text-center">
                    <h5 class="title08 page__h4">案内ページ</h5>
                </div>
                <div class="col-sm-4 p-2">
                    <a :href="data.mfj_event_main_data_url" target="_blank">
                        <i class="fas fa-external-link-alt"></i> 詳細はこちら
                    </a>
                </div>
            </div>
            <div class="row mb-1 collapse" :id="'list_data_' + index">
              <div class="col-sm-2 mb-1  bg_org_gray p-2 text-center" v-if="data.race_owner_name">
                  <h5 class="title08 page__h4">主催者名</h5>
              </div>
              <div class="col-sm-4 mb-1 p-2" v-if="data.race_owner_name">
                  <p v-html="data.race_owner_name"></p>
              </div>
              <div class="col-sm-2 mb-1  bg_org_gray p-2 text-center">
                  <h5 class="title08 page__h4">連絡先</h5>
              </div>
              <div class="col-sm-4 mb-1 p-2">
                  <p class="mb-1">
                      <span class="badge bg-secondary me-2">連絡先名称</span>
                      <span v-if="data.race_owner_access_name" v-html="data.race_owner_access_name"></span>
                      <span v-else v-html="data.race_owner_name"></span>
                  </p>
                  <p class="mb-1">
                      <span class="badge bg-secondary me-2">連絡先TEL</span>
                      <span v-if="data.race_owner_access_tel" v-html="data.race_owner_access_tel"></span>
                      <span v-else v-html="data.race_owner_tel"></span>
                  </p>
                  <p class="mb-1" v-if="data.race_owner_access_cellphone">
                      <span class="badge bg-secondary me-2">連絡先携帯</span>
                      <span v-html="data.race_owner_access_cellphone"></span>
                  </p>
              </div>

              <div v-if="data.mfj_event_sub_data_entry_price" class="col-sm-2 mb-1  bg_org_gray p-2 text-center">
                  <h5 class="title08 page__h4">エントリー料金</h5>
              </div>
              <div v-if="data.mfj_event_sub_data_entry_price" class="col-sm-4 mb-1 p-2">
                  <span v-html="data.mfj_event_sub_data_entry_price"></span>
              </div>
            </div>
            <div class="row mb-1">
              <div v-if="Object.keys(data.classes).length > 0" class="col-sm-2 bg_org_gray p-2 text-center">
                  <h5 class="title08 page__h4">承認クラス</h5>
                  <br>
                  <span style="font-size:90%;font-weight:normal;">※◎は昇格ポイント対象クラス</span>
              </div>
              <div v-if="Object.keys(data.classes).length > 0" class="col-sm-4 p-2">
                  <div class="row mb-1 pb-1 border-bottom border-dotted" v-for="class_name in data.classes" :key="class_name">
                    <div class="col-12">
                      <span v-html="class_name"></span>
                    </div>
                  </div>
              </div>
              <div class="col-sm-2 mb-1 bg_org_gray p-2 text-center">
                  <h5 class="title08 page__h4">エントリー</h5>
              </div>
              <div class="col-sm-4 mb-1 bg_org_gray p-2 text-center">
                  <div class="mb-2">
                    <entry-link 
                    :label="'エントリーはこちら'" :user_token="get_token" 
                    :member_license="member_license"
                    :race_data_cd="data.mfj_event_main_data_cd" 
                    :race_data_seq="data.mfj_event_sub_data_cd_seq"
                    :race_data_url="data.mfj_event_main_data_url"
                    :load-msevent-token-obj="loadMsEventTokenObj"></entry-link>
                  </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-3 offset-md-9">
                  <a :href="'#list_data_' + index" class="" style="font-size: 80%;" :aria-controls="'list_data_' + index" data-bs-toggle="collapse">詳細を確認する<i class="fas fa-chevron-down"></i></a>
              </div>
            </div>
          </div>
        </div>

        <div class="my-4" v-if="list.length > 0">
            <nav aria-label="Page navigation">
                <ul class="pagination" v-if="pager">
                    <li v-if="pager.prev" class="page-item"><a class="page-link" href="#" @click="pagerPrev">{{pager.prev.label}}</a></li>
                    <li class="page-item" :class="{ active: item.pageNum == sprm.page }" v-for="(item, i) in pager.center" :key="i">
                      <span v-if="item.pageNum==sprm.page" class="page-link" >{{item.label}}</span>
                      <a v-else class="page-link" href="#" @click="pagerClick(item.pageNum)">{{item.label}}</a>
                      
                    </li>
                    <li v-if="pager.next" class="page-item"><a class="page-link" href="#" @click="pagerNext">{{pager.next.label}}</a></li>
                </ul>
            </nav>
        </div>
        <div class="my-4 text-center">
            <a href="#body" class="select_bg_clear text-center d-inline-block px-3 py-2 mb-2">トップへ戻る</a>
        </div>


      </div>
    </div>
  </section>
</template>

<script>
// import { mapState } from 'vuex'
import BsSelect from '../../atoms/BsSelect.vue'
import config from '../../../const'
// import Common from '../../../common/common'
import EntryLink from '../MsEvent/EntryLink.vue';
import axios from 'axios';

export default {
  name: 'RequestPromotionView',
  data: function () {
    return {
      targetid: this.$store.state.auth.userId,
      btnLabel: '',
      data_obj: {},
      form_obj: {},
      member_license_promotion_obj: [],
      member_license_obj: [],
      message:
        'レースエントリー一覧です',
      term_year_obj: [],
      selected_license: [],
      sprm: {
              fromDate: '',
              toDate: '',
              eventCd: [],
              raceType: [],
              raceTypeCd: [],
              areaCd: '',
              prefCd: '',
              onepage: 10,
              page: 0
            },
      clearsParam: {},
      list: [],
      num: 0,
      cnt: 0,
      pager: {},
    }
  },
  components: {
    BsSelect,
    EntryLink,
    //   BsMsgAlert,
    // BsCheckBox,
  },
  methods: {
    async loadMsEventTokenObj(){
      const params = {}
      params['stat'] = [1]
      params['id'] = this.get_auth.userId
      console.log('prams',params);
      let token = ''
      try {
        token = await this.basicPosts_S(
          config.BASE_API_URL + '/member/mseventtoken',
          params
        )
      } catch (err) {
        console.log(err)
      }
      console.log('token', token)
      return token
    },
    async toggleSelectedLicense(license_cd){
      const tmps = [...this.selected_license]
      if(this.chkSelectedLicense(license_cd)){
        const index = this.selected_license.findIndex(
          (license) => license == license_cd
        )
        tmps.splice(index, 1)
      }
      else{
        tmps.push(license_cd)
      }
      this.selected_license = tmps
    },

    pagerPrev(){
      if(this.sprm.page > 0){
          this.sprm.page -= 1;
      }
      this.searchAction();
    },
    pagerNext(){
      this.sprm.page += 1;
      this.searchAction();
    },
    pagerClick(pageNum){
      this.sprm.page = pageNum;
      this.searchAction();
    },
    async clearSearchParam(){
      this.sprm = {...this.clearsParam}
    },
    async searchAction(){

      const params = new FormData();
      if(typeof this.sprm === 'object'){
        Object.keys(this.sprm).forEach(key => {
          if(this.sprm[key]){
            params.append(key, this.sprm[key])
          }
        })
      }
      if(Array.isArray(this.selected_license) && this.selected_license.length > 0){
        const sel_license = []
        this.selected_license.forEach(license => {
          sel_license.push(license)
        })
          params.append('licenseCd', sel_license)
      }
      let sso_url = config.SSO_SITE_URL
      if(process.env.VUE_APP_ENV === 'production'){
        sso_url += '/mfj_renewal'
      }
      // params.append('fromDate', today);
      // const url = 'https://www.ms-event.net/mfj/user/?a=mfj_event.mfj_event_search'
      const url = sso_url + '/event/?a=mfj_event.mfj_event_search'
      console.log(url)
      axios
      .post(url, params)
      .then((res) => {
          console.log('then', res);
          if(res.data && res.data.list){
              this.list = res.data.list;
              this.num = res.data.num;
              this.cnt = res.data.cnt;
              this.pager = res.data.pager;
          }
      })
      .catch((error) => {
          console.log('error', error);
      })
      .finally(() => {
          console.log('finally');
      });
    },
    async loadMemberLicenseObj() {
      const params = {}
      params['stat'] = [1]
      params['fixed'] = 1
      // params['license_valid_date'] = this.today
      params['license_valid_date_f'] = this.today
      params['m_id'] = this.$store.state.auth.userId
      await this.basicPosts_S(config.BASE_API_URL + '/member_license/lists', params)
        .then(async (response) => {
          console.log('loadMemberLicenseObj', response)
          this.member_license_obj =
            response.data && response.data.body 
              ? response.data.body
              : []
        })
        .catch(async (err) => {
          console.log(err)
          this.member_license_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
  },
  computed: {
    member_license: function(){
      const tmps = []
      if(Array.isArray(this.member_license_list) && this.member_license_list.length > 0){
        this.member_license_list.forEach(license => {
          // if(!tmps.includes(license.old_short_label)){
            tmps.push(license.old_short_label)
          // }
        })
      }
      return tmps
    },
    chkSelectedLicense: function(){
      const selected = this.selected_license
      return function(license_cd){
        return selected.includes(license_cd)
      }
    },
    btnSelectedLicenseClass: function(){
      const chkSel = this.chkSelectedLicense
      return function(license_cd){
        if(chkSel(license_cd)){
          return 'btn btn-primary me-2'
        }
        return 'btn btn-light btn-outline-secondary me-2'
      }
    },
    today: function(){
      const date = new Date();
      return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + (date.getDate())).slice(-2);
    },
    member_license_list: function(){
      // return this.member_license_obj.filter(license => parseInt(license.license_class) == 1)


      const tmps = []
      const tmps_chk = []
      if(Array.isArray(this.member_license_obj) && this.member_license_obj.length > 0){
        this.member_license_obj.filter(license => parseInt(license.license_class) == 1).forEach(license => {
          if(!tmps_chk.includes(license.license_cd)){
            tmps.push(license)
            tmps_chk.push(license.license_cd)
          }
        })
      }
      return tmps
    },
    selectAreaCd: function(){
      const area_cds = {...config.SELECT_AREA_CD}
      const tmps = []
      Object.keys(area_cds).forEach(cd => {
        tmps.push({
          key: cd,
          label: area_cds[cd]
        })
      })
      return tmps
    },
    selectPrefCdTmp: function(){
      const pref_cds = config.SELECT_PREF_CD
      const tmps = {}
      Object.keys(pref_cds).forEach(pref_cd => {
        if(!tmps[pref_cd]){
          tmps[pref_cd] = []
        }
        Object.keys(pref_cds[pref_cd]).forEach(key => {
          tmps[pref_cd].push({
            key: key,
            label: pref_cds[pref_cd][key]
          })
        })
      })
      return tmps
    },
    selectPrefCd: function(){
      const tmps = {...this.selectPrefCdTmp}
      return function(target){
        if(tmps[target]){
          return tmps[target]
        }
        return []
      }
    },
    get_token: function(){
      return this.$store.state.auth.token
    },
  },
  async created() {
    this.clearsParam = Object.assign({}, JSON.parse(JSON.stringify(this.sprm)));
    this.sprm.fromDate = this.today
    await this.loadMemberLicenseObj();
    await this.searchAction()
  },
  mounted: function () {
    // console.log('tags_list', this.tags_list);
  },
  props: {},
}
</script>
